import React, {useState} from 'react';
import ReactMarkdown from "react-markdown";
import posts from "../data/posts";
import CodeBlock from "./CodeBlock";

async function getPost(key) {
    return Array.from(posts).find(post => post.key === key)
}

function BlogPost(props) {

    const [title, setTitle] = useState("");
    const [date, setDate] = useState("");
    const [content, setContent] = useState("");

    getPost(props.blogKey)
        .then(post => {

            setTitle(post.title);
            setDate(post.date);

            // let files = fs.readdirSync('/');
            const url = `/posts/${post.key}/post.md`;
            const Http = new XMLHttpRequest();
            Http.addEventListener("load", evt => {
                // console.log(Http.responseText);
                setContent(Http.responseText);
            });
            Http.open("GET", url);
            Http.send();
        });

    return (
        <div>
            {/*Main jumbotron for a primary marketing message or call to action*/}
            <div className="jumbotron graph-back d-flex align-items-center">
                <div className="row d-flex align-items-center mt-2">
                    <div className="col-9">
                        <h1 className="display-3 mt-5">{title}</h1>
                        <p>Pete Meltzer &mdash; {date}</p>
                    </div>
                </div>
            </div>

            <div className={"container"}>
                <ReactMarkdown
                    source={content}
                    renderers={{code: CodeBlock}}
                    escapeHtml={false}/>
            </div>

        </div>
    )
}

export default BlogPost;